import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f2f51b7e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f2f51b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f51b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f51b7e')) {
      api.createRecord('f2f51b7e', component.options)
    } else {
      api.reload('f2f51b7e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f2f51b7e&scoped=true&", function () {
      api.rerender('f2f51b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23OF5XPc07hMq/JS/comp/DocBox.vue"
export default component.exports